import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCatalog } from '../../../context/CatalogContext';
import { MonoLabel } from '../../Editorial';
import HubRow from './HubRow';
import StatusChip from './StatusChip';

/* done/inProgress/notStarted already answers "is this section filled in?" —
   the chip just relabels that existing tri-state for the athlete. */
const CHIP_STATE = { done: 'complete', inProgress: 'partial', notStarted: 'empty' };

/* Athletics half of the Recruit ▸ Me card: sport, position, secondary sports
   and accolades in one row. Ported from `athleticsHalf` in RecruitMeView.swift. */

/* Sport-NEUTRAL glyph. The apps make the same call and say why: there is no
   sport→symbol mapping, and hardcoding one shows a football to a swimmer. */
const FieldGlyph = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M12 5v14" />
    <circle cx="12" cy="12" r="2.5" />
  </svg>
);

export default function AthleticsHalf({ profile, accolades = [] }) {
  const navigate = useNavigate();
  const catalog = useCatalog();

  const sportSlug = catalog.sportSlugFor(profile?.sport);
  const sport = catalog.getSport(sportSlug);
  const hasPositions = ((sport && sport.positions) || []).length > 0;

  const parts = [];
  if (profile?.sport) {
    parts.push(profile.position_primary
      ? `${profile.sport} (${profile.position_primary})`
      : profile.sport);
  }
  const extras = (profile?.sports_played || []).filter(Boolean);
  if (extras.length) parts.push(extras.join(', '));
  // Accolades live in their own ledger, not on the profile.
  if (accolades.length) parts.push('Accolades');
  const subtitle = parts.length ? parts.join(' · ') : 'Pick your sport and position';

  let state = 'done';
  if (!profile?.sport) state = 'notStarted';
  else if (hasPositions && !profile.position_primary) state = 'inProgress';

  const pillLabel = { notStarted: 'Start', inProgress: '1 to add', done: null }[state];

  return (
    <div className="me-half">
      <div className="me-eyebrow">
        <span>
          <MonoLabel>Athletics</MonoLabel>
          <StatusChip id="athletics" state={CHIP_STATE[state]} />
        </span>
        <span className="me-eyebrow__hint">Sport &amp; honors</span>
      </div>
      <div className="me-rule" />
      <HubRow
        icon={<FieldGlyph />}
        title="My Sports"
        subtitle={subtitle}
        state={state}
        pillLabel={pillLabel}
        onClick={() => navigate('/my-sports')}
        testId="recruit_me_my_sports"
      />
    </div>
  );
}
